import { Button, Container } from "@chakra-ui/react";

interface IBottomFixedButton {
    isLoading?: boolean;
    isDisabled: boolean;
    text: string;
    colorScheme: string;
    onClick: () => void;
}

function BottomFixedButton({
    isLoading = false,
    isDisabled,
    text,
    colorScheme,
    onClick,
}: IBottomFixedButton) {
    return (
        <Container
            position={"fixed"}
            maxW={"768px"}
            minW={"320px"}
            bottom={0}
            w="100%"
            h="80px"
            px={"20px"}
            bg="white"
            display="flex"
            alignItems={"center"}
            justifyContent="center"
            borderTop={"1px"}
            borderTopColor="#e0e0e0"
            zIndex="modal"
        >
            <Button
                isLoading={isLoading}
                isDisabled={isDisabled}
                colorScheme={colorScheme}
                w="100%"
                h={"50px"}
                fontSize={"16px"}
                fontWeight="semibold"
                onClick={onClick}
            >
                {text}
            </Button>
        </Container>
    );
}
export default BottomFixedButton;
